var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#FF5F14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.52 27V25.14C16.3733 24.4333 17.2 23.7333 18 23.04C18.8133 22.3467 19.5333 21.66 20.16 20.98C20.8 20.3 21.3067 19.64 21.68 19C22.0667 18.3467 22.26 17.7133 22.26 17.1C22.26 16.5267 22.1 16.02 21.78 15.58C21.4733 15.14 20.96 14.92 20.24 14.92C19.5067 14.92 18.9533 15.16 18.58 15.64C18.2067 16.12 18.02 16.7 18.02 17.38H15.54C15.5667 16.3533 15.7933 15.5 16.22 14.82C16.6467 14.1267 17.2133 13.6133 17.92 13.28C18.6267 12.9333 19.42 12.76 20.3 12.76C21.7267 12.76 22.8333 13.1533 23.62 13.94C24.42 14.7133 24.82 15.72 24.82 16.96C24.82 17.7333 24.64 18.4867 24.28 19.22C23.9333 19.9533 23.4733 20.66 22.9 21.34C22.3267 22.02 21.7067 22.66 21.04 23.26C20.3733 23.8467 19.7267 24.3933 19.1 24.9H25.16V27H15.52Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondOrange);
export default __webpack_public_path__ + "static/media/secondOrange.cda9cf24293a4e1f56a0bb4e20419440.svg";
export { ForwardRef as ReactComponent };